// When a database can't be reached, every screen says so in the same words.
//
// The server answers 503 with a reason and a message written for the person
// reading the screen (backend/services/databaseRegistry.js): its server is
// away, the database is unavailable there, or its credentials don't work. A
// screen repeats that message instead of guessing - an empty result list, a
// missing tile or "an admin can show types" all say the wrong thing when the
// truth is that nothing could be asked at all.
//
// 503 is never an expired session: the axios interceptor in App.js only signs
// anyone out on a 403, and nothing here clears the session.
export const DATABASE_REASONS = ["offline", "unavailable", "credentials"];

const reasonOf = (value) => (typeof value === "string" ? value : "");

// From a result an action returned: { success: false, status, reason, msg }.
export const isDatabaseUnreachable = (res) =>
  Boolean(res && res.success === false && res.status === 503 && DATABASE_REASONS.includes(reasonOf(res.reason)));

// From a rejected axios error, for callers that still catch one.
export const unreachableFromError = (err) =>
  isDatabaseUnreachable({ success: false, status: err?.response?.status, reason: err?.response?.data?.reason });

// Said when the server gave no words of its own.
export const UNREACHABLE_FALLBACK = "This database can't be reached right now. Try again shortly or tell bpExperts.";

// What to show. The server's message first, because it names the database and
// says who can fix it.
export const unreachableMessage = (res) => (res && typeof res.msg === "string" && res.msg.trim()) || UNREACHABLE_FALLBACK;
